import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { formatDate, sortedPosts } from "@/pages/Blog";

export default function LatestNews() {
    const posts = sortedPosts.slice(0, 3);
    return (
        <section className="border-b border-border bg-white" data-testid="latest-news-section">
            <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
                <div className="flex flex-wrap items-end justify-between gap-4">
                    <h2 className="font-display text-2xl font-bold text-primary sm:text-3xl">Latest News</h2>
                    <Link to="/blog" className="inline-flex items-center gap-1.5 text-base font-semibold text-primary hover:underline" data-testid="latest-news-all-link">
                        All articles <ArrowRight size={16} />
                    </Link>
                </div>
                <ul className="mt-8 grid gap-5 md:grid-cols-3">
                    {posts.map((p) => (
                        <li key={p.slug}>
                            <Link to={`/blog/${p.slug}`} className="group flex h-full flex-col rounded-lg border border-border bg-white p-6 transition-shadow hover:shadow-md" data-testid={`latest-news-${p.slug}`}>
                                <time dateTime={p.date} className="text-sm text-muted-foreground">{formatDate(p.date)}</time>
                                <h3 className="mt-2 font-display text-xl font-bold leading-snug text-primary">{p.title}</h3>
                                <p className="mt-3 line-clamp-3 flex-1 text-base text-foreground/80">{p.excerpt}</p>
                                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
                                    Read article <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                                </span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
